/**
 * coachingPrompts.ts
 * Pre-built coaching messages for FAM Advisors.
 * Advisors click to send — these are NOT auto-sent.
 * Plain English only — no Islamic finance terms.
 */

export const COACHING_PROMPTS = {
  low_sharing_early: {
    id: 'low_sharing_early',
    subject: 'Quick tip to boost your campaign',
    body: `Hi {creatorName},\n\nShare your campaign link on social media — the first 48 hours set the pace!\n\nHere's your link: {campaignUrl}\n\nYour FAM Advisor,\n{advisorName}`,
    trigger: 'day <= 2 AND supporterCount < 5',
  },
  under_30_midweek: {
    id: 'under_30_midweek',
    subject: 'Your campaign needs a push',
    body: `Hi {creatorName},\n\nAsk 5 close friends to share your campaign link today. Personal texts work better than social posts!\n\nYour link: {campaignUrl}\n\nYour FAM Advisor,\n{advisorName}`,
    trigger: 'day >= 3 AND progressPct < 30',
  },
  under_50_day5: {
    id: 'under_50_day5',
    subject: 'Final stretch — you\'re almost there',
    body: `Hi {creatorName},\n\nReach out to family members who haven't contributed yet. A quick call or text with your link goes a long way.\n\nYour link: {campaignUrl}\n\nYour FAM Advisor,\n{advisorName}`,
    trigger: 'day >= 5 AND progressPct < 50',
  },
  under_70_day6: {
    id: 'under_70_day6',
    subject: 'Last day push!',
    body: `Hi {creatorName},\n\nText your campaign link directly to the people who said they'd help. Tomorrow is Day 7!\n\nYour link: {campaignUrl}\n\nYour FAM Advisor,\n{advisorName}`,
    trigger: 'day >= 6 AND progressPct < 70',
  },
  strong_momentum: {
    id: 'strong_momentum',
    subject: 'Your campaign is on fire!',
    body: `Hi {creatorName},\n\nAmazing progress — your community is showing up! Keep sharing and encourage your supporters to spread the word.\n\nYour FAM Advisor,\n{advisorName}`,
    trigger: 'progressPct >= 70',
  },
  funded_select_vehicle: {
    id: 'funded_select_vehicle',
    subject: 'Time to pick your vehicle!',
    body: `Hi {creatorName},\n\nYour campaign is funded! Log in to review your vehicle options and select your payment terms. You have 14 days.\n\nhttps://fam.autos\n\nYour FAM Advisor,\n{advisorName}`,
    trigger: "status === 'offer_made'",
  },
  custom: {
    id: 'custom',
    subject: '',
    body: '',
    trigger: 'manual',
  },
} as const;

export type CoachingPromptId = keyof typeof COACHING_PROMPTS;

/** Replace placeholders in a coaching prompt */
export function renderPrompt(
  promptId: CoachingPromptId,
  data: { creatorName: string; campaignUrl: string; advisorName: string },
): { subject: string; body: string } {
  const prompt = COACHING_PROMPTS[promptId];
  const replace = (text: string) =>
    text
      .replace(/\{creatorName\}/g, data.creatorName)
      .replace(/\{campaignUrl\}/g, data.campaignUrl)
      .replace(/\{advisorName\}/g, data.advisorName);
  return {
    subject: replace(prompt.subject),
    body: replace(prompt.body),
  };
}
